import React from 'react';
import { motion } from 'framer-motion';

const MobileBottomNav = ({ navItems, activeSection, onSectionChange }) => {
  // Limit to 5 items for optimal mobile UX
  const displayItems = navItems.slice(0, 5);

  const handleNavClick = (itemId) => {
    onSectionChange(itemId);
    // Haptic feedback on navigation
    if (navigator.vibrate) {
      navigator.vibrate(10);
    }
  };

  return (
    <motion.div
      initial={{ y: 100 }}
      animate={{ y: 0 }}
      transition={{ type: "spring", damping: 25 }}
      className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-black/98 backdrop-blur-xl border-t border-white/[0.03] safe-area-bottom"
    >
      {/* Premium compact navigation */}
      <div className="relative flex items-center justify-around px-3 py-2">
        {displayItems.map((item, index) => {
          const isActive = activeSection === item.id;
          return (
            <button
              key={item.id}
              onClick={() => handleNavClick(item.id)}
              className={`flex flex-col items-center justify-center min-w-[52px] p-1.5 rounded-lg transition-all duration-300 relative ${
                isActive
                  ? 'bg-white/[0.03]'
                  : 'active:scale-95'
              }`}
              aria-label={item.label}
              aria-current={isActive ? 'page' : undefined}
            >
              {/* Compact icon with subtle response */}
              <motion.div
                whileTap={{ scale: 0.9 }}
                className={`transition-all duration-300 ${
                  isActive
                    ? item.customStyle ? 'text-amber-400/80' : 'text-emerald-400/80'
                    : 'text-white/30'
                }`}
              >
                {React.cloneElement(item.icon, { className: 'w-[18px] h-[18px]' })}
              </motion.div>

              {/* Minimal label - only show for active */}
              {isActive && (
                <motion.span
                  initial={{ opacity: 0, y: -2 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -2 }}
                  className="text-[9px] font-medium tracking-wide text-white/70 mt-0.5"
                >
                  {item.label.split(' ')[0]}
                </motion.span>
              )}

              {/* Premium thin indicator - top position */}
              {isActive && (
                <motion.div
                  layoutId="mobileNavIndicator"
                  className="absolute top-0 left-0 right-0 mx-auto w-8 h-[2px] bg-gradient-to-r from-emerald-500/80 to-violet-500/80 rounded-b-full"
                  transition={{ type: "spring", bounce: 0.15, duration: 0.5 }}
                />
              )}
            </button>
          );
        })}
      </div>

      {/* Subtle bottom accent line */}
      <div className="absolute bottom-0 left-0 right-0 h-[1px] bg-gradient-to-r from-transparent via-white/[0.02] to-transparent" />
    </motion.div>
  );
};

export default MobileBottomNav;